import AddIcon from '@mui/icons-material/Add';
import { IconButton, Stack, Switch } from '@mui/material';
import React from 'react';
import { FaRegEdit } from 'react-icons/fa';
import { getAllInvoiceExtras, InvoiceExtraTypeMap, saveInvoiceExtra } from 'wisestep-api';
import { WsButton, WsDataTable } from 'wisestep-base';

import { SettingsPageLayout } from '../../../components/SettingsPageLayout';
import { useWorkspaceContext } from '../../../context';
import {
  getSettingBreadCrumbList,
  ISettingBreadCrumbTypes,
  Pages,
} from '../../../features/teams/helper/defaultValues';
import { AtsCustomAPIAccess, useAtsCustomAPIAccess } from '../../../hooks/useAtsCustomAPIAccess';
import { useDialog } from '../../../hooks/useDialog';
import { useFetch } from '../../../hooks/useFetch';
import { invoiceSettingsIndexOptions } from '../../invoicing/helper/InvocieSettingsHelper';

import InvoiceExtraForm from './InvoiceExtraForm';

const InvoiceExtraSettings = () => {
  const [invoiceExtras, setInvoiceExtras] = useFetch(getAllInvoiceExtras);
  const [openDialog, closeDialog] = useDialog();

  const workspaceContext = useWorkspaceContext();
  const { access: atsCustomAccessControl } = useAtsCustomAPIAccess([
    AtsCustomAPIAccess.MANAGE_CLIENT_SETTINGS,
  ]);

  const manageAccess = workspaceContext.owns || atsCustomAccessControl[0];

  const fetchAll = async () => {
    const response = await getAllInvoiceExtras();
    setInvoiceExtras(response.data);
  };

  const openInvoiceExtraFormDialog = (defaultValues?) => {
    openDialog({
      children: (
        <InvoiceExtraForm
          onSave={() => {
            closeDialog();
            fetchAll();
          }}
          onClose={closeDialog}
          {...(defaultValues && { defaultValues })}
        />
      ),
    });
  };

  const columns = [
    {
      Header: 'Invoice Extra',
      accessor: 'name',
    },
    {
      Header: 'Calculation',
      accessor: 'type',
      Cell: ({ value }) => {
        return value ? InvoiceExtraTypeMap[value] : null;
      },
    },
    {
      Header: 'Extra Type',
      accessor: 'accessor1',
      Cell: ({ row: { original } }) => {
        const types: string[] = [];
        original.percentage && types.push('Percentage');
        original.absolute && types.push('Amount');
        return types.join(', ');
      },
    },
    {
      Header: 'Active',
      accessor: 'active',
      Cell: (props) => {
        const row = props.row.original;
        return (
          <Switch
            defaultChecked={row.active}
            onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
              saveInvoiceExtra({ ...row, active: event.target.checked }).then(fetchAll);
            }}
          />
        );
      },
    },
    {
      Header: 'Created By',
      accessor: 'createdByName',
    },
    {
      Header: '',
      accessor: 'edit',
      Cell: (props) => {
        const row = props.row.original;
        return (
          <IconButton onClick={() => openInvoiceExtraFormDialog(row)}>
            <FaRegEdit />
          </IconButton>
        );
      },
    },
  ];

  return (
    <>
      <SettingsPageLayout
        title="Invoice Extra"
        indexOptions={invoiceSettingsIndexOptions}
        breadCrumnbsList={getSettingBreadCrumbList(
          ISettingBreadCrumbTypes.INVOICE,
          Pages['INVOICE_EXTRA']
        )}
      >
        {manageAccess && (
          <Stack direction="row" p={2} justifyContent="flex-end" alignItems="center">
            <WsButton
              startIcon={<AddIcon />}
              variant="outlined"
              onClick={() => openInvoiceExtraFormDialog()}
            >
              Add Invoice Extra
            </WsButton>
          </Stack>
        )}
        <WsDataTable dense columns={columns} data={invoiceExtras ?? []} />
      </SettingsPageLayout>
    </>
  );
};

export default InvoiceExtraSettings;
